import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import api from "../../../api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

const NewsEventsSection = () => {
  const { miniSlug, slug } = useParams();
  const [sectionData, setSectionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/api/${miniSlug}/${slug}/news-events`
        );
        const data = response.data;

        setSectionData({
          title: data.title || "News & Events",
          news: data.items?.news || [],
          events: data.items?.events || [],
        });
      } catch (err) {
        console.error("Error fetching News & Events:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [miniSlug, slug]);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container || !sectionData?.events || sectionData.events.length <= 3)
      return;

    const content = container.querySelector("ul");
    if (content && !container.dataset.cloned) {
      const clone = content.cloneNode(true);
      clone.style.marginTop = "0px";
      container.appendChild(clone);
      container.dataset.cloned = "true";
    }

    let scrollSpeed = 0.6;
    let animationFrame;

    const scrollStep = () => {
      container.scrollTop += scrollSpeed;
      if (container.scrollTop >= content.scrollHeight) {
        container.scrollTop = 0;
      }
      animationFrame = requestAnimationFrame(scrollStep);
    };

    const startScrolling = () => {
      if (!animationFrame) animationFrame = requestAnimationFrame(scrollStep);
    };

    const stopScrolling = () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
    };

    startScrolling();
    container.addEventListener("mouseenter", stopScrolling);
    container.addEventListener("mouseleave", startScrolling);

    return () => {
      stopScrolling();
      container.removeEventListener("mouseenter", stopScrolling);
      container.removeEventListener("mouseleave", startScrolling);
    };
  }, [sectionData]);

  if (loading || !sectionData || !sectionData.news.length) return <></>;

  return (
    <section className="news-events-section pb-5" id="news-events">
      <div className="container">
        <div className="sec-title text-center ">
          <h2>{sectionData.title}</h2>
        </div>

        <div className="row align-items-center">
      <div className="col-lg-7">
  <Swiper
    modules={[Autoplay]}
    autoplay={false}
    loop={false}
    spaceBetween={30}
    slidesPerView={2}   // DEFAULT for desktop
    className="news-events-carousel mb-4 mb-md-0"

    breakpoints={{
      0: {                 // 📱 Mobile
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {               // 💻 Tablet & up
        slidesPerView: 2,
        spaceBetween: 20,
      },
    }}
  >
    {sectionData.news.map((item) => (
      <SwiperSlide key={item.id}>
        <div
          className="event-item mb-5 hover-zoomin"
          onClick={() => setSelectedItem(item)}
        >
          <div className="thumb">
            <img
              src={`${process.env.REACT_APP_API_URL}/public/${item.image}`}
              alt={item.title}
              className="img-fluid rounded"
            />
          </div>

          <div className="event-content">
            <div className="date">
              <strong>{item.display_date?.split(" ")[0]}</strong>{" "}
              {item.display_date?.split(" ").slice(1).join(" ")}
            </div>

            <h3>{item.title}</h3>

            <p>
              {item.description?.length > 150
                ? `${item.description.substring(0, 150)}...`
                : item.description}
            </p>

            <div className="time">
              <strong>Click here</strong>
            </div>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</div>


          <div className="col-lg-5 d-flex flex-column justify-content-center">
            <div
              ref={scrollContainerRef}
              className="event-style1-content-box"
              style={{
                maxHeight: "400px",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <ul className="p-0 m-0">
                {sectionData.events.map((item, index) => (
                  <li
                    key={item.id || index}
                    className="event-list-item"
                    style={{ listStyle: "none" }}
                  >
                    <div
                      className={`single-event-box-style1 ${index % 2 === 0 ? "single-event-box-style1--style2" : ""
                        }`}
                    >
                      <div className="date-box">
                        <h2>{item.display_date?.split(" ")[0] || "--"}</h2>
                        <p>{item.display_date?.split(" ").slice(1).join(" ")}</p>
                      </div>
                      <div className="title-box">
                        {item.pdf ? (
                          <a
                            href={`${process.env.REACT_APP_API_URL}/public/${item.pdf}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="event-title text-primary fw-semibold"
                            style={{
                              textDecoration: "none",
                              transition: "color 0.2s",
                            }}
                          >
                            {item.title}
                          </a>
                        ) : (
                          <h3
                            className="event-title"
                            style={{ cursor: "default" }}
                          >
                            {item.title}
                          </h3>
                        )}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {selectedItem && (
        <div
          className="facility-modal-overlay"
          onClick={() => setSelectedItem(null)}
        >
          <div className="facility-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedItem(null)}>
              &times;
            </button>
            <h3>{selectedItem.title}</h3>
            <div className="row align-items-center">
              <div className="col-lg-6">
                {selectedItem.image && (
                  <img
                    src={`${process.env.REACT_APP_API_URL}/public/${selectedItem.image}`}
                    alt={selectedItem.title}
                    className="modal-image img-fluid rounded"
                  />
                )}
              </div>
              <div className="col-lg-6 modal-text">
                {selectedItem.full_description?.includes("<") ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: selectedItem.full_description,
                    }}
                  />
                ) : (
                  <p>
                    {selectedItem.full_description || selectedItem.description}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default NewsEventsSection;
